// Mock data for MRFA Electoral Campaign Website

export const translations = {
  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      vision: "Vision & Mission",
      pillars: "Nos Piliers",
      programs: "Programmes",
      calendar: "Calendrier",
      team: "Équipe",
      contact: "Contact"
    },
    
    // Hero Section
    hero: {
      slogan: "Ansanm pou n leve foutbòl la !",
      title: "Refondation du Football Haïtien",
      subtitle: "Programme Officiel 2026-2030",
      description: "Ensemble, bâtissons un football haïtien structuré, transparent et compétitif. Une nouvelle ère commence maintenant.",
      cta1: "Notre Vision",
      cta2: "Rejoignez-nous"
    },
    
    // Vision Section
    vision: {
      title: "Notre Vision",
      subtitle: "Reconstruire le football haïtien comme levier d'unité, de formation et de développement national",
      mission: "Notre Mission",
      missionText: "Structurer, former, transparenter, moderniser et renforcer le football à tous les niveaux.",
      values: "Nos Valeurs",
      valuesList: [
        { name: "Intégrité", desc: "Honnêteté, rigueur et transparence dans toutes nos actions" },
        { name: "Discipline", desc: "Respect des règles, engagements et institutions" },
        { name: "Solidarité", desc: "Unir clubs, régions et diaspora pour un objectif commun" },
        { name: "Excellence", desc: "Professionnalisme dans toutes les sphères du football" },
        { name: "Responsabilité", desc: "Redevabilité pour nos actions et résultats" },
        { name: "Inclusion", desc: "Accès pour tous les jeunes dans un environnement sûr" }
      ]
    },
    
    // Strategic Pillars
    pillars: {
      title: "Nos 5 Piliers Stratégiques",
      subtitle: "Un plan d'action complet pour transformer le football haïtien",
      list: [
        {
          id: 1,
          name: "Gouvernance & Transparence",
          icon: "Shield",
          description: "Moderniser la FHF pour un fonctionnement clair, participatif et professionnel",
          actions: [
            "Réforme des statuts de la FHF",
            "Création d'une commission d'éthique indépendante",
            "Digitalisation de la gestion administrative",
            "Décentralisation vers les ligues régionales",
            "Publication annuelle des états financiers"
          ]
        },
        {
          id: 2,
          name: "Formation & Jeunesse",
          icon: "Users",
          description: "Développer les jeunes talents à travers des programmes structurés",
          actions: [
            "Obligation des catégories jeunes dans tous les clubs",
            "Championnats nationaux jeunes organisés",
            "Programme '1 entreprise = 1 championnat junior'",
            "Institut national de formation des entraîneurs",
            "Intégration du football dans les écoles"
          ]
        },
        {
          id: 3,
          name: "Football Professionnel",
          icon: "Trophy",
          description: "Professionnaliser le football haïtien avec un modèle durable",
          actions: [
            "Création de la Ligue Haïtienne Professionnelle (LHP)",
            "Système de licensing des clubs",
            "Partenariats internationaux pour infrastructures",
            "Valorisation des droits médias",
            "Soutien post-carrière pour les joueurs"
          ]
        },
        {
          id: 4,
          name: "Infrastructures & Développement",
          icon: "Building",
          description: "Reconstruire et moderniser les infrastructures sportives",
          actions: [
            "Plan national 'Yon teren pou chak komin'",
            "Construction de centres régionaux de formation",
            "Coopération internationale pour installations",
            "Fonds d'entretien des infrastructures",
            "Formation de techniciens locaux"
          ]
        },
        {
          id: 5,
          name: "Économie & Partenariats",
          icon: "DollarSign",
          description: "Bâtir une économie du football solide et transparente",
          actions: [
            "Fonds national de développement du football",
            "Accompagnement des clubs en business plan",
            "Label 'Partenaire du Football Haïtien'",
            "Plateforme de merchandising en ligne",
            "Tournoi annuel de la diaspora"
          ]
        }
      ]
    },
    
    // Special Programs
    programs: {
      title: "Programmes Spéciaux",
      subtitle: "Des initiatives ciblées pour un impact maximal",
      list: [
        {
          name: "Jeunesse & Espoir",
          description: "Aucun enfant ne sera privé du droit de jouer au football",
          highlights: [
            "Intégration scolaire obligatoire",
            "Camps nationaux 'Foot pou tout' gratuits",
            "Bourses sportives pour jeunes talents",
            "Encadrement psychosocial",
            "Promotion du civisme et leadership"
          ]
        },
        {
          name: "Football Féminin",
          slogan: "Fann se fôs foutbôl la",
          description: "Égalité des genres et reconnaissance des femmes",
          highlights: [
            "Création d'une Ligue nationale féminine",
            "Campagne de promotion de la participation féminine",
            "Soutien matériel et technique",
            "Bureau de protection des athlètes féminines",
            "Code de conduite éthique"
          ]
        },
        {
          name: "Diaspora & Diplomatie",
          description: "Mobiliser la diaspora haïtienne comme atout stratégique",
          highlights: [
            "Cellule Football & Diaspora",
            "Système d'observation des talents",
            "Tournoi annuel de la diaspora",
            "Diplomatie sportive internationale",
            "Accords de coopération technique"
          ]
        }
      ]
    },
    
    // Calendar
    calendar: {
      title: "Calendrier de Mise en Œuvre",
      subtitle: "Un plan d'action progressif et mesurable 2026-2030",
      years: [
        {
          year: "2026",
          title: "Année de la Réforme",
          focus: "Consolidation institutionnelle et normalisation",
          objectives: [
            "Réforme des statuts de la FHF",
            "Mise en place de la commission d'éthique",
            "Audit complet de la situation actuelle",
            "Lancement du dialogue social"
          ]
        },
        {
          year: "2027",
          title: "Année du Redémarrage",
          focus: "Relance des compétitions et formation",
          objectives: [
            "Reprise régulière des championnats",
            "Lancement des programmes jeunesse",
            "Premiers camps de formation nationaux",
            "Début de la digitalisation"
          ]
        },
        {
          year: "2028",
          title: "Année des Infrastructures",
          focus: "Développement régional et équipements",
          objectives: [
            "Construction des premiers centres régionaux",
            "Rénovation de 20 terrains communaux",
            "Lancement du fonds d'infrastructure",
            "Formation des techniciens locaux"
          ]
        },
        {
          year: "2029",
          title: "Année de la Professionnalisation",
          focus: "Structuration du football professionnel",
          objectives: [
            "Création officielle de la LHP",
            "Mise en place du licensing des clubs",
            "Négociation des droits médias",
            "Salaire minimum pour joueurs professionnels"
          ]
        },
        {
          year: "2030",
          title: "Année de la Consolidation",
          focus: "Évaluation et pérennisation des acquis",
          objectives: [
            "Bilan complet du mandat",
            "Consolidation des structures créées",
            "Expansion des programmes réussis",
            "Planification stratégique 2031-2035"
          ]
        }
      ]
    },
    
    // KPIs
    kpis: {
      title: "Nos Engagements Mesurables",
      list: [
        { value: "100%", label: "Transparence Financière", icon: "Eye" },
        { value: "500", label: "Entraîneurs Certifiés", icon: "Award" },
        { value: "85%", label: "Clubs Conformes", icon: "CheckCircle" },
        { value: "4", label: "Centres Régionaux", icon: "MapPin" },
        { value: "15K", label: "Jeunes Inscrits", icon: "Users" },
        { value: "50", label: "Terrains Rénovés", icon: "Flag" }
      ]
    },
    
    // Team
    team: {
      title: "Notre Équipe",
      subtitle: "Une coalition nationale de dirigeants, anciens joueurs, entrepreneurs et membres de la diaspora",
      description: "Le Mouvman Refondasyon Fotbòl Ayisyen (MRFA) rassemble des acteurs de toutes les régions et de la diaspora, unis par une vision commune pour la jeunesse haïtienne.",
      roles: [
        "Dirigeants de clubs",
        "Anciens joueurs professionnels",
        "Éducateurs sportifs",
        "Entrepreneurs et communicants",
        "Membres de la société civile",
        "Représentants de la diaspora"
      ]
    },
    
    // Testimonials
    testimonials: {
      title: "Ils Soutiennent Notre Vision",
      list: [
        {
          name: "Jean-Pierre Michel",
          role: "Ancien international haïtien",
          quote: "Cette vision représente l'avenir que nous avons toujours souhaité pour le football haïtien. Il est temps d'agir."
        },
        {
          name: "Marie-Chantal Louis",
          role: "Présidente, Club AS Capoise",
          quote: "Enfin un programme qui comprend les défis réels des clubs et propose des solutions concrètes."
        },
        {
          name: "Dr. Pierre Emmanuel",
          role: "Membre de la diaspora, USA",
          quote: "La diaspora est prête à s'investir. Ce programme nous donne l'opportunité de contribuer efficacement."
        }
      ]
    },
    
    // Contact
    contact: {
      title: "Rejoignez le Mouvement",
      subtitle: "Ensemble, refondons le football haïtien",
      form: {
        name: "Nom complet",
        email: "Email",
        phone: "Téléphone",
        role: "Votre rôle",
        message: "Message",
        submit: "Envoyer",
        success: "Merci! Nous vous contactons bientôt.",
        newsletter: "Je souhaite recevoir la newsletter"
      },
      roles: [
        "Joueur/Joueuse",
        "Dirigeant de club",
        "Entraîneur",
        "Membre de la diaspora",
        "Sponsor/Partenaire",
        "Supporter",
        "Autre"
      ],
      info: {
        title: "Contactez-nous",
        email: "contact@mrfa2026.ht",
        phone: "+509 XXXX-XXXX",
        address: "Port-au-Prince, Haïti"
      }
    },
    
    // Footer
    footer: {
      tagline: "Refonder le football haïtien, c'est refonder la confiance du pays en lui-même.",
      quickLinks: "Liens Rapides",
      followUs: "Suivez-nous",
      copyright: "© 2026 MRFA. Tous droits réservés."
    }
  },
  
  ht: {
    // Navigation
    nav: {
      home: "Akèy",
      vision: "Vizyon & Misyon",
      pillars: "Pilye Nou yo",
      programs: "Pwogram",
      calendar: "Kalandriye",
      team: "Ekip",
      contact: "Kontak"
    },
    
    // Hero Section
    hero: {
      slogan: "Ansanm pou n leve foutbòl la !",
      title: "Refondasyon Foutbòl Ayisyen",
      subtitle: "Pwogram Ofisyèl 2026-2030",
      description: "Ansanm, ann bati yon foutbòl ayisyen estrikture, transparan ak konpetitif. Yon nouvo epòk ap kòmanse kounye a.",
      cta1: "Vizyon Nou",
      cta2: "Vin jwenn nou"
    },
    
    // Vision Section
    vision: {
      title: "Vizyon Nou",
      subtitle: "Rebati foutbòl ayisyen kòm yon zouti pou inite, fòmasyon ak devlopman nasyonal",
      mission: "Misyon Nou",
      missionText: "Estrikture, fòme, fè transparan, modènize ak ranfòse foutbòl nan tout nivo.",
      values: "Valè Nou yo",
      valuesList: [
        { name: "Entegrite", desc: "Onètete, rigè ak transparans nan tout aksyon nou yo" },
        { name: "Disiplin", desc: "Respè règleman, angajman ak enstitisyon yo" },
        { name: "Solidarite", desc: "Ini klib, rejyon ak dyaspora pou yon objektif komen" },
        { name: "Ekselans", desc: "Pwofesyonalis nan tout domèn foutbòl la" },
        { name: "Responsablite", desc: "Rann kont pou aksyon ak rezilta nou yo" },
        { name: "Enklizyon", desc: "Aksè pou tout jèn nan yon anviwònman sekirize" }
      ]
    },
    
    // Strategic Pillars
    pillars: {
      title: "5 Pilye Estratejik Nou yo",
      subtitle: "Yon plan aksyon konplè pou transfòme foutbòl ayisyen",
      list: [
        {
          id: 1,
          name: "Gouvènans & Transparans",
          icon: "Shield",
          description: "Modènize FHF pou yon fonksyònman klè, patipatif ak pwofesyonèl",
          actions: [
            "Refòm estatì FHF la",
            "Kreye yon komisyon etik endepandan",
            "Dijitalizasyon jesyon administratif",
            "Desantalizasyon nan lig rejyonal yo",
            "Piblikasyon anyèl finans yo"
          ]
        },
        {
          id: 2,
          name: "Fòmasyon & Jènes",
          icon: "Users",
          description: "Devlope jèn talan yo atravè pwogram estrikture",
          actions: [
            "Obligasyon kategori jèn nan tout klib",
            "Chanpyona nasyonal jèn òganize",
            "Pwogram '1 antrepriz = 1 chanpyona junior'",
            "Enstiti nasyonal fòmasyon antrenè",
            "Entegrasyon foutbòl nan lekòl yo"
          ]
        },
        {
          id: 3,
          name: "Foutbòl Pwofesyonèl",
          icon: "Trophy",
          description: "Pwofesyonalize foutbòl ayisyen ak yon modèl dirab",
          actions: [
            "Kreye Lig Ayisyen Pwofesyonèl (LHP)",
            "Sistèm lisans klib yo",
            "Patenarya entènasyonal pou enfrastrikti",
            "Valorizasyon dwa medya",
            "Sipò aprè karyè pou jwè yo"
          ]
        },
        {
          id: 4,
          name: "Enfrastrikti & Devlopman",
          icon: "Building",
          description: "Rebati ak modènize enfrastrikti espòtif yo",
          actions: [
            "Plan nasyonal 'Yon teren pou chak komin'",
            "Konstriksyon sant rejyonal fòmasyon",
            "Koperasyon entènasyonal pou enstalasyon",
            "Fon pou antretyen enfrastrikti",
            "Fòmasyon teknisyen lokal yo"
          ]
        },
        {
          id: 5,
          name: "Ekonomi & Patenarya",
          icon: "DollarSign",
          description: "Bati yon ekonomi foutbòl solid ak transparan",
          actions: [
            "Fon nasyonal devlopman foutbòl",
            "Akonpanyman klib yo nan plan biznis",
            "Etikèt 'Patnè Foutbòl Ayisyen'",
            "Platfòm vann machandiz anliy",
            "Tounwa anyèl dyaspora a"
          ]
        }
      ]
    },
    
    // Special Programs
    programs: {
      title: "Pwogram Espesyal",
      subtitle: "Inisyativ sible pou yon enpak maksimòm",
      list: [
        {
          name: "Jènes & Espwa",
          description: "Okenn timoun p ap prive dwa jwe foutbòl",
          highlights: [
            "Entegrasyon obligatwa nan lekòl",
            "Kan nasyonal 'Foot pou tout' gratis",
            "Bous espòtif pou jèn talan",
            "Ankadre sikolosyal",
            "Pwomosyon sivis ak lidèchip"
          ]
        },
        {
          name: "Foutbòl Fanm",
          slogan: "Fann se fôs foutbôl la",
          description: "Egalite sèks ak rekonesans fanm yo",
          highlights: [
            "Kreye yon Lig nasyonal fanm",
            "Kanpay pou patisipasyon fanm",
            "Sipò materyèl ak teknik",
            "Biwo pwoteksyon atlèt fanm",
            "Kòd konduit etik"
          ]
        },
        {
          name: "Dyaspora & Diplomasi",
          description: "Mobilize dyaspora ayisyen kòm yon ato estratejik",
          highlights: [
            "Selil Foutbòl & Dyaspora",
            "Sistèm obsèvasyon talan yo",
            "Tounwa anyèl dyaspora a",
            "Diplomasi espòtif entènasyonal",
            "Akò koperasyon teknik"
          ]
        }
      ]
    },
    
    // Calendar
    calendar: {
      title: "Kalandriye Realizasyon",
      subtitle: "Yon plan aksyon pwogresif ak mezire 2026-2030",
      years: [
        {
          year: "2026",
          title: "Ane Refòm",
          focus: "Konsolidasyon enstitisyonèl ak nòmalizasyon",
          objectives: [
            "Refòm estatì FHF la",
            "Mete kanpe komisyon etik",
            "Odisyon konplè sitiyasyon aktyèl",
            "Lanse dyalòg sosyal"
          ]
        },
        {
          year: "2027",
          title: "Ane Redemaraj",
          focus: "Relans konpetisyon ak fòmasyon",
          objectives: [
            "Reprann chanpyona regilye",
            "Lanse pwogram jènes yo",
            "Premye kan fòmasyon nasyonal",
            "Kòmanse dijitalizasyon"
          ]
        },
        {
          year: "2028",
          title: "Ane Enfrastrikti",
          focus: "Devlopman rejyonal ak ekipman",
          objectives: [
            "Konstriksyon premye sant rejyonal",
            "Renovasyon 20 teren kominotè",
            "Lanse fon enfrastrikti",
            "Fòmasyon teknisyen lokal yo"
          ]
        },
        {
          year: "2029",
          title: "Ane Pwofesyonalizasyon",
          focus: "Estriktirasyon foutbòl pwofesyonèl",
          objectives: [
            "Kreye ofisyèlman LHP",
            "Mete kanpe lisans klib yo",
            "Negosyasyon dwa medya",
            "Salè minimòm pou jwè pwofesyonèl"
          ]
        },
        {
          year: "2030",
          title: "Ane Konsolidasyon",
          focus: "Evalyasyon ak peryenizasyon reyalizasyon yo",
          objectives: [
            "Bilan konplè manda a",
            "Konsolide estrikti ki kreye yo",
            "Ekspansyon pwogram ki reyisi yo",
            "Planifikasyon estratejik 2031-2035"
          ]
        }
      ]
    },
    
    // KPIs
    kpis: {
      title: "Angajman Nou yo ki Mezire",
      list: [
        { value: "100%", label: "Transparans Finansye", icon: "Eye" },
        { value: "500", label: "Antrenè Sètifye", icon: "Award" },
        { value: "85%", label: "Klib Konfòm", icon: "CheckCircle" },
        { value: "4", label: "Sant Rejyonal", icon: "MapPin" },
        { value: "15K", label: "Jèn Enskri", icon: "Users" },
        { value: "50", label: "Teren Renove", icon: "Flag" }
      ]
    },
    
    // Team
    team: {
      title: "Ekip Nou",
      subtitle: "Yon koyalisyon nasyonal dirijan, ansyen jwè, antreprenè ak manm dyaspora",
      description: "Mouvman Refondasyon Fotbòl Ayisyen (MRFA) rasanble aktè nan tout rejyon yo ak dyaspora a, ini pa yon vizyon komen pou jènes ayisyen yo.",
      roles: [
        "Dirijan klib",
        "Ansyen jwè pwofesyonèl",
        "Edikasyon espòtif",
        "Antreprenè ak kominikasyon",
        "Manm sosyete sivil",
        "Reprezantan dyaspora"
      ]
    },
    
    // Testimonials
    testimonials: {
      title: "Yo Sipòte Vizyon Nou",
      list: [
        {
          name: "Jean-Pierre Michel",
          role: "Ansyen entènasyonal ayisyen",
          quote: "Vizyon sa a reprezante avni n te toujou swete pou foutbòl ayisyen. Li lè pou n aji."
        },
        {
          name: "Marie-Chantal Louis",
          role: "Prezidant, Club AS Capoise",
          quote: "Finalman yon pwogram ki konprann defi reyèl klib yo epi pwopoze solisyon konkresman."
        },
        {
          name: "Dr. Pierre Emmanuel",
          role: "Manm dyaspora, USA",
          quote: "Dyaspora a pare pou envesti. Pwogram sa a ba nou opòtinite pou kontribye efikasman."
        }
      ]
    },
    
    // Contact
    contact: {
      title: "Vin Jwenn Mouvman an",
      subtitle: "Ansanm, ann refondasyon foutbòl ayisyen",
      form: {
        name: "Non konplè",
        email: "Imèl",
        phone: "Telefòn",
        role: "Wòl ou",
        message: "Mesaj",
        submit: "Voye",
        success: "Mèsi! N ap kontakte w byento.",
        newsletter: "Mwen vle resevwa newsletter"
      },
      roles: [
        "Jwè/Jwèz",
        "Dirijan klib",
        "Antrenè",
        "Manm dyaspora",
        "Sponsò/Patnè",
        "Sipatè",
        "Lòt"
      ],
      info: {
        title: "Kontakte nou",
        email: "contact@mrfa2026.ht",
        phone: "+509 XXXX-XXXX",
        address: "Pòtoprens, Ayiti"
      }
    },
    
    // Footer
    footer: {
      tagline: "Refondasyon foutbòl ayisyen, se refondasyon konfyans peyi a nan tèt li.",
      quickLinks: "Lyen Rapid",
      followUs: "Swiv nou",
      copyright: "© 2026 MRFA. Tout dwa rezève."
    }
  }
};

export const images = {
  hero: "https://images.unsplash.com/photo-1764703666646-acc2f7d48857?crop=entropy&cs=srgb&fm=jpg&q=85",
  heroOverlay: "https://images.unsplash.com/photo-1635272024672-aaf4810e2f47?crop=entropy&cs=srgb&fm=jpg&q=85",
  haiti1: "https://images.unsplash.com/photo-1762828841207-44b4c70f96a2?crop=entropy&cs=srgb&fm=jpg&q=85",
  haiti2: "https://images.unsplash.com/photo-1752673508944-2578f0d62ce1?crop=entropy&cs=srgb&fm=jpg&q=85",
  haiti3: "https://images.unsplash.com/photo-1635272024682-1fe2937e3eff?crop=entropy&cs=srgb&fm=jpg&q=85",
  haiti4: "https://images.unsplash.com/photo-1567792264121-682b7b4d9376?crop=entropy&cs=srgb&fm=jpg&q=85",
  youth1: "https://images.unsplash.com/photo-1745012010615-47abbeb3e906?crop=entropy&cs=srgb&fm=jpg&q=85",
  youth2: "https://images.unsplash.com/photo-1767902012345-bd31f0ba76d7?crop=entropy&cs=srgb&fm=jpg&q=85",
  youth3: "https://images.unsplash.com/photo-1717584146940-118a65525da8?crop=entropy&cs=srgb&fm=jpg&q=85",
  youth4: "https://images.unsplash.com/photo-1765372674571-afef5d3771b2?crop=entropy&cs=srgb&fm=jpg&q=85",
  stadium1: "https://images.unsplash.com/photo-1764703666646-acc2f7d48857?crop=entropy&cs=srgb&fm=jpg&q=85",
  stadium2: "https://images.unsplash.com/photo-1635272024672-aaf4810e2f47?crop=entropy&cs=srgb&fm=jpg&q=85",
  stadium3: "https://images.unsplash.com/photo-1673324669026-e2409b9faf8d?crop=entropy&cs=srgb&fm=jpg&q=85",
  stadium4: "https://images.unsplash.com/photo-1635272024682-1fe2937e3eff?crop=entropy&cs=srgb&fm=jpg&q=85",
  ball1: "https://images.unsplash.com/photo-1752673508944-2578f0d62ce1?crop=entropy&cs=srgb&fm=jpg&q=85",
  ball2: "https://images.unsplash.com/photo-1616514169928-a1e40c6f791c?crop=entropy&cs=srgb&fm=jpg&q=85",
  celebration1: "https://images.unsplash.com/photo-1574465636391-3d2f98aee2ea",
  celebration2: "https://images.unsplash.com/photo-1742095228943-1b0ceb0fd82e"
};
